// extracted by css-extract-rspack-plugin
export default {"field":"field-vuNzdt","fields":"fields-il4vlg","actions":"actions-X7lkBY"};